export const lineChartOptions: {[key: string]: any} = {
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [{
      gridLines: {
        color: 'rgba(255,255,255,0.5)',
        zeroLineColor: 'rgba(255,255,255,1)',
      },
      ticks: {
        fontColor: '#fff',
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        fontStyle: '300'
      }
    }],
    yAxes: [{
      gridLines: {
        color: 'rgba(255,255,255,0.5)',
        zeroLineColor: 'rgba(255,255,255,1)'
      },
      ticks: {
        // max: 0,
        // min: 0,
        // stepSize: 0,
        fontColor: '#fff',
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        fontStyle: '300'
      }
    }]
  },
  legend: {
    display: true,
    position: 'top',
    labels: {
      boxWidth: 14,
      fontFamily: 'Source Sans Pro',
      fontSize: 14,
      fontColor: '#fff',
      fontStyle: '300'
    }
  }
};

export const lineChartData: {[key: string]: any} = {
  labels: null,
  datasets: [
    {
      label: '',
      fill: false,
      lineTension: 0.1,
      backgroundColor: '#6aa8e4',
      borderColor: '#6aa8e4',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#6aa8e4',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#6aa8e4',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      spanGaps: false,
      data: null
    },
  ],
};

export const doughnutChartOptions = {
	maintainAspectRatio: false,
	responsive: true,
	segmentShowStroke: true,
	legend: {
		display: true,
		position: 'bottom',
		labels: {
			boxWidth: 14,
			fontFamily: 'Source Sans Pro',
			fontSize: 14,
			fontStyle: '400',
			fontColor: '#565350'
		}
  },
  tooltips: {
    callbacks: {
      label: (tooltipItem: any, data: any) => {

        let dataset = data.datasets[tooltipItem.datasetIndex],
            total = dataset.data.reduce(function (previousValue: any, value: any) { return (previousValue + value); }),
            currentValue = dataset.data[tooltipItem.index],
            precentage = Math.floor(((currentValue / total) * 100) + 0.5);

        return precentage + "%";
      }
    }
  }
};

export const doughnutChartData: { [key: string]: any } = {
	labels: null,
	datasets: [
		{
			label: null,
			borderColor: 'transparent',
			borderWidth: 1,
			backgroundColor: ['#F075A2', '#9DCC64', '#64B4DD', '#F3C46C', '#FF8363', '#BFBFBF'],
			pointBackgroundColor: '#fff',
			data: null
		}
	],
};